import { render, staticRenderFns } from "./RevisoesListagem.vue?vue&type=template&id=05fa9b60"
import script from "./RevisoesListagem.vue?vue&type=script&lang=js"
export * from "./RevisoesListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports